'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const SocialIcon = require('../../../global/components/SocialIcon');
const EmailIcon = require('dibs-vg/dist/react/email');
const hasContextTypes = require('../../../global/reactHelpers/hasContextTypes');

const PdpEmailIcon = React.createClass(hasContextTypes({
    propTypes: {
        vertical: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        itemPk: PropTypes.string.isRequired,
        stfOnClick: PropTypes.func.isRequired,
        iconType: PropTypes.string
    },

    _handleClick(e) {
        e.preventDefault();
        this.props.stfOnClick(this.props);
    },

    render() {
        const {iconType} = this.props;

        return (
            <SocialIcon onClick={this._handleClick} Icon={EmailIcon} iconName="email" iconType={iconType} data-tn='email'/>
        );
    }
}));

module.exports = PdpEmailIcon;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/social/PdpEmailIcon.jsx